import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { InfoTooltipWrapper, Icon, InfoContent } from './styled';
import { Info } from '../../helpers/icon-dictionary';
import ContextModal from '../context-modal';

const InfoTooltip = ({ modalWidth = 240, children }) => {
  const [infoPosition, setInfoPostion] = useState({});
  const infoRef = useRef(null);
  const [showInfo, setShowInfo] = useState(false);

  const getInfoPos = () => {
    const { height, width } = infoRef.current.getBoundingClientRect();
    const positionX = (width + (width / 2)) - modalWidth;
    const positionArrowFixed = modalWidth - width;
    const positionY = height + 10;

    setInfoPostion({ positionX, positionY, positionArrowFixed });
  };

  return (
    <InfoTooltipWrapper
      ref={infoRef}
      onMouseEnter={() => { setShowInfo(true); }}
      onMouseLeave={() => { setShowInfo(false); }}
    >
      <Icon>
        <Isvg src={Info} cacheGetRequests onLoad={getInfoPos} />
      </Icon>
      <ContextModal
        {...infoPosition}
        show={showInfo}
        fixedParent
        modalWidth={modalWidth}
      >
        <InfoContent onMouseLeave={() => { setShowInfo(false); }}>
          {children}
        </InfoContent>
      </ContextModal>
    </InfoTooltipWrapper>

  );
};

InfoTooltip.propTypes = {
  modalWidth: PropTypes.number,
  children: PropTypes.any
};

export default InfoTooltip;
